// ----------------------------------------------------------------------------
// Snippet: Card Label
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

import './_cart-footer.scss';